import { createStore } from 'jotai';

// One store for the whole app, so non-React code (event handlers built
// outside components, tests) can read and write the same state.
export const jotaiStore = createStore();
